import React from 'react';
export function SolutionSection() {
  return <section data-id="element-329">
      <div className="max-w-4xl mx-auto text-center" data-id="element-330">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#00C853]/50 text-[#00C853] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-331">
          🏆 EDULABS™ MEGAPACK ITALIANO LISTO
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-6" data-id="element-332">
          6 Tomos + 6 Bonos — A1 → C2
          <br data-id="element-333" />
          <span className="text-[#00C853]" data-id="element-334">420+ páginas — Todo resuelto.</span>
        </h2>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl mt-12" data-id="element-335">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-336">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['A1', 'A2', 'B1', 'B2', 'C1/C2', 'Kit Eval.'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
              backgroundColor: color,
              border: '2px solid #00C853'
            }} data-id="element-337">
                  <span className="text-white text-xs font-bold" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-338">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#00C853] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-339">
            6 TOMOS COMPLETOS
          </div>
        </div>
      </div>
    </section>;
}